/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import * as Customwidgets from "../customwidgets";

const Transaction = (props) => {
  const [apetura, setApertura] = useState("");
  const [movimporcuenta, setdatos] = useState([]);
  const [saldoActual, setsaldoact] = useState([]);
  const [cargos, setcargos] = useState([]);
  const [abonos, setabonos] = useState([]);

  const changeValue = (e) => {
    let valueSelect = e.target.value;
    if (e !== "") {
      props.item.content.accounts
        .filter((cuenta) => cuenta.acntname === valueSelect)
        .map((k) => {
          setApertura(k.acntnopening);
          setsaldoact(k.balance.today);
          setcargos(k.balance.charges);
          setabonos(k.balance.passes);
          setdatos(k.transactions);
        });
    }
  };

  return (
    <div className="size-12 ">
      <div className="card">
        <div className="form-row hdr_transaction">
          <div className="col-ico ">
            <i className="ibon-exchange inb4"></i>
          </div>
          <h2 className="col-7">Movimientos</h2>
          <div className="col-4  inputIconRight">
            <div className="fx-search-transaction">
              <div className="searchInput">
                <input
                  type="text"
                  className="ibon-account"
                  placeholder="Clave de rastreo o no. de referencia"
                />
                <i className="ibon-search tap"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="tableTools ">
          <div className="row col-12">
            <div className="col-3">
              <div className="inputIconRight form-row desktop pnl-apertura">
                <div className="neutral" style={{marginLeft: "0.5vw"}}>Apertura: </div>
                <div className="label_saldo_apertura">{apetura} </div>
              </div>
            </div>
            <div className="col-3">
              <div className="inputIconRight inputGroup desktop fx-box-transaction">
                <select name="" onChange={changeValue.bind(this)}>
                  <option value="">--</option>
                  {props.item.content.accounts.map((k, i) => {
                    return (
                      <option value={k.acntname} key={`account-${i}`}>cuenta {k.acntname}</option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="col-3 calendar-widget-table">
              {<Customwidgets.Calendar props={"tr"} />}
            </div>
            <div className="col-3">
              <div className="inputIconRight inputGroup desktop ">
                <select className="" name=""></select>
              </div>
            </div>
          </div>
          <div className="inputIconRight inputGroup desktop fx-trans-i">
            <i className="ibon-download inb2 transformed"></i>
          </div>
        </div>

        <div className="tableTools pnl-saldos">
          <div className="animated row col-12">
            <div className="tableToolsCargo fx-tableToolsSaldoAct desktop col-3">
              <div className="neutral" style={{marginLeft: "0.5vw"}}>Saldo actual: </div>
              <div className="label_saldo_apertura">${saldoActual}</div>
            </div>

            <div className="tableToolsCargo fx-tableToolsCargos desktop col-3">
              <i className="ibon-account indigo"></i>
              <div className="neutral" style={{marginLeft: "0.5vw"}}>Cargos: </div>
              <div className="label-position">- ${cargos}</div>
            </div>

            <div className="tableToolsAbonos fx-tableToolsAbonos desktop col-3">
              <i className="ibon-account vivere"></i>
              <div className="neutral" style={{marginLeft: "0.5vw"}}>Abonos: </div>
              <div className="vivere label-position">+ {abonos}</div>
            </div>

            <div className="tableToolsAbonos fx-tableToolsPag desktop col-2">
              <div className="tableTools justify-end fx-pnl-tools">
                <div className="tableToolspages">
                  <span className="neutral" style={{marginLeft: "0.5vw"}}>1 - XX de 3900</span>
                  <i className="tap ibon-chevron-left indigo"></i>
                  <i className="tap ibon-chevron-right indigo"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table-content">
          <table>
            <tbody>
              <tr>
                <th className="neutral">
                  Fecha <i className="tap ibon-chevron-down"></i>
                </th>
                <th className="neutral">
                  Descripción <i className="tap ibon-chevron-down"></i>
                </th>
                <th className="neutral">
                  Monto <i className="tap ibon-chevron-down"></i>
                </th>
                <th className="neutral">
                  Estatus <i className="tap ibon-chevron-down"></i>
                </th>
                <th className="neutral">
                  Tipo de Tarjeta <i className="tap ibon-chevron-down"></i>
                </th>
                <th></th>
              </tr>
              {movimporcuenta.map((m, i) => {
                return (
                  <tr key={`mov-${i}`}>
                    <td>{m.date}</td>
                    <td>{m.description}</td>
                    <td>{m.amount}</td>
                    <td>{m.status}</td>
                    <td>{m.type_transaction}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Transaction;
